import { Mail, Phone, User } from 'lucide-react';
import type { Guest } from '@/types/guest.types';

interface ReservationGuestSectionProps {
  guest: Guest | undefined;
}

export function ReservationGuestSection({ guest }: ReservationGuestSectionProps) {
  return (
    <section className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
        Hóspede Principal
      </h3>
      <div className="glass rounded-xl p-4 space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-linear-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
            <User className="w-6 h-6 text-primary" />
          </div>
          <div>
            <p className="font-semibold">
              {guest ? `${guest.first_name ?? ''} ${guest.last_name ?? ''}`.trim() || '-' : '-'}
            </p>
            <p className="text-sm text-muted-foreground">{guest?.document_number ?? '-'}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 pt-2 border-t border-border/30">
          <div className="flex items-center gap-2 text-sm">
            <Mail className="w-4 h-4 text-muted-foreground" />
            <span className="truncate">{guest?.email ?? '-'}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Phone className="w-4 h-4 text-muted-foreground" />
            <span>{guest?.phone ?? '-'}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
